import { request } from '@mairistem/tools';
import type Service from '../../interfaces/simulation/service';

const url = '/api/finances/comptabilite/piecescomptables/services';

export const getService = (identifiant: number): Promise<Service> =>
	request.get(`${url}/${identifiant}`);
